import { render, staticRenderFns } from "./CMobileTable.vue?vue&type=template&id=31a7e399&scoped=true"
import script from "./CMobileTable.vue?vue&type=script&lang=js"
export * from "./CMobileTable.vue?vue&type=script&lang=js"
import style0 from "./CMobileTable.vue?vue&type=style&index=0&id=31a7e399&scoped=true&lang=css"
import style1 from "./CMobileTable.vue?vue&type=style&index=1&id=31a7e399&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7e399",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a7e399')) {
      api.createRecord('31a7e399', component.options)
    } else {
      api.reload('31a7e399', component.options)
    }
    module.hot.accept("./CMobileTable.vue?vue&type=template&id=31a7e399&scoped=true", function () {
      api.rerender('31a7e399', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CMobileTable.vue"
export default component.exports